module.exports = __webpack_public_path__ + "static/polygon_right-0fc33b6e5577f6d2a46bbfa09a4ed0fb.png";